/**
 * Model for Document related details.
 *
 * @author jagpreet.singh@vernuso.com
 */
export class Document {
    id: number;
    name: string;
    dateOfUpload: Date;
    docOwner: string;
    entityId: number;
    validFrom: Date;
    validTo: Date;
    validatedBy: string;
    type: number;
    allMeta = new Map<string, string>();
    labels = new Map<number, string>();
    locked = false;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/document.model.ts